<div class="form-container">
  <div class="form-card">
    <app-button label="Back" variant="text" color="primary" icon="pi pi-arrow-left" [fullWidth]="false"
      class="mb-3 d-inline-block" (clicked)="goBack()">
    </app-button>

    <form (ngSubmit)="onSubmit()" autocomplete="off" class="vertical-form" novalidate>
      <h3 class="mb-2 fs-5">Club Address</h3>
      <p class="text-secondary mb-4 fs-6">Provide your club's location and mailing address.</p>

      <!-- Country -->
      <div class="field mb-3">
        <label for="inputCountrySelect" class="form-label">Country <span aria-hidden="true">*</span></label>
        <p-select id="inputCountry" inputId="inputCountrySelect" name="country"
          [(ngModel)]="clubInformation.clubAddress.country"
          [options]="countries" optionLabel="label" optionValue="code"
          placeholder="Select a Country" [filter]="true" [autofocusFilter]="false" filterBy="label"
          [class.ng-invalid]="submitted() && !clubInformation.clubAddress.country"
          ariaLabel="Country" panelStyleClass="comp-dark-panel"
          class="w-full" aria-required="true"
          (onChange)="onCountryChange($event)" />
        @if (submitted() && !clubInformation.clubAddress.country) {
          <small id="inputCountry-error" role="alert" class="p-error">Country is required.</small>
        }
      </div>

      <!-- Address Line 1 & 2 -->
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <div class="field">
            <label for="inputAddress" class="form-label">Address Line 1 <span aria-hidden="true">*</span></label>
            <input pInputText id="inputAddress" name="address"
              [(ngModel)]="clubInformation.clubAddress.address"
              [class.ng-invalid]="submitted() && !clubInformation.clubAddress.address?.trim()"
              class="w-full" aria-required="true"
              [attr.aria-invalid]="submitted() && !clubInformation.clubAddress.address?.trim() ? true : null"
              [attr.aria-describedby]="submitted() && !clubInformation.clubAddress.address?.trim() ? 'inputAddress-error' : null" />
            @if (submitted() && !clubInformation.clubAddress.address?.trim()) {
              <small id="inputAddress-error" role="alert" class="p-error">Address is required.</small>
            }
          </div>
        </div>
        <div class="col-md-6">
          <div class="field">
            <label for="inputAddress2" class="form-label">Address Line 2</label>
            <input pInputText id="inputAddress2" name="address2"
              [(ngModel)]="clubInformation.clubAddress.address2" class="w-full" />
          </div>
        </div>
      </div>

      <!-- City, State, Postcode -->
      <div class="row g-3 mb-3">
        <div class="col-md-5">
          <div class="field">
            <label for="inputCity" class="form-label">City</label>
            <input pInputText id="inputCity" name="city"
              [(ngModel)]="clubInformation.clubAddress.city" class="w-full" />
          </div>
        </div>
        <div class="col-md-4">
          <div class="field">
            <label for="inputState" class="form-label">State / County <span aria-hidden="true">*</span></label>
            <input pInputText id="inputState" name="state"
              [(ngModel)]="clubInformation.clubAddress.state"
              [class.ng-invalid]="submitted() && !clubInformation.clubAddress.state?.trim()"
              class="w-full" aria-required="true"
              [attr.aria-invalid]="submitted() && !clubInformation.clubAddress.state?.trim() ? true : null"
              [attr.aria-describedby]="submitted() && !clubInformation.clubAddress.state?.trim() ? 'inputState-error' : null" />
            @if (submitted() && !clubInformation.clubAddress.state?.trim()) {
              <small id="inputState-error" role="alert" class="p-error">State is required.</small>
            }
          </div>
        </div>
        <div class="col-md-3">
          <div class="field">
            <label for="inputZip" class="form-label">Postcode <span aria-hidden="true">*</span></label>
            <input pInputText id="inputZip" name="postCode"
              [(ngModel)]="clubInformation.clubAddress.postCode"
              [class.ng-invalid]="submitted() && !clubInformation.clubAddress.postCode?.trim()"
              class="w-full" aria-required="true"
              [attr.aria-invalid]="submitted() && !clubInformation.clubAddress.postCode?.trim() ? true : null"
              [attr.aria-describedby]="submitted() && !clubInformation.clubAddress.postCode?.trim() ? 'inputZip-error' : null" />
            @if (submitted() && !clubInformation.clubAddress.postCode?.trim()) {
              <small id="inputZip-error" role="alert" class="p-error">Required.</small>
            }
          </div>
        </div>
      </div>

      <h3 class="mb-2 mt-3 fs-5">Additional Details</h3>
      <p class="text-secondary mb-3 fs-6">Set your club's transaction currency and provide your terms &amp; conditions.</p>

      <div class="row g-3 mb-2">
        <div class="col-md-6">
          <div class="field">
            <label for="currency" class="form-label">Transaction Currency</label>
            <input pInputText id="currency" name="currency"
              [(ngModel)]="clubInformation.currency"
              class="w-full" readonly aria-describedby="currency-hint" />
            <small id="currency-hint" class="field-hint">Set automatically from your country.</small>
          </div>
        </div>
        <div class="col-md-6">
          <div class="field">
            <label for="clubTnC" class="form-label">Club T&amp;C URL <span aria-hidden="true">*</span></label>
            <input pInputText id="clubTnC" name="clubTnC" inputmode="url"
              [(ngModel)]="clubInformation.clubTnC"
              [class.ng-invalid]="submitted() && (!clubInformation.clubTnC?.trim() || !isValidUrl(clubInformation.clubTnC))"
              class="w-full" aria-required="true"
              [attr.aria-describedby]="submitted() && (!clubInformation.clubTnC?.trim() || !isValidUrl(clubInformation.clubTnC)) ? 'clubTnC-error' : null"
              [attr.aria-invalid]="submitted() && (!clubInformation.clubTnC?.trim() || !isValidUrl(clubInformation.clubTnC)) ? true : null" />
            @if (submitted() && !clubInformation.clubTnC?.trim()) {
              <small id="clubTnC-error" role="alert" class="p-error">Club T&amp;C URL is required.</small>
            } @else if (submitted() && !isValidUrl(clubInformation.clubTnC)) {
              <small id="clubTnC-error" role="alert" class="p-error">Enter a valid URL starting with http:// or https://</small>
            }
          </div>
        </div>
      </div>

      <!-- Club Logo -->
      <div class="field mb-2">
        <label class="form-label">Club Logo</label>

        @if (!croppedImage() && !appIconUrl()) {
          <div class="mt-2">
            <button type="button" class="file-upload-trigger d-flex flex-column align-items-center justify-content-center gap-2 p-4 w-100 rounded-3"
              (click)="triggerFileInput()" aria-label="Upload club logo">
              <i class="pi pi-upload" aria-hidden="true"></i>
              <span>Click to upload</span>
              <small class="text-secondary">Allowed: PNG, JPG or JPEG</small>
            </button>
          </div>
        }

        @if (croppedImage() || appIconUrl()) {
          <div class="logo-upload-container d-flex align-items-start gap-3">
            <div class="logo-preview position-relative">
              <img [src]="croppedImage() ? croppedImage() : appIconUrl()" alt="Club logo preview" width="90" height="90" />
              <button type="button" class="btn-remove" (click)="removeUploadedImage()" aria-label="Remove logo">
                <i class="pi pi-times" aria-hidden="true"></i>
              </button>
            </div>
            <div class="logo-actions d-flex flex-column gap-2">
              <app-button label="Change Logo" type="button" variant="outline" color="primary" [fullWidth]="false"
                (clicked)="triggerFileInput()">
              </app-button>
              <span class="text-secondary fs-7">Allowed: PNG, JPG or JPEG</span>
            </div>
          </div>
        }

        <input #fileInput type="file" style="display: none" accept="image/png,image/jpeg,.png,.jpg,.jpeg" (change)="onHiddenFileSelect($event)" aria-hidden="true">

        <app-image-cropper-dialog
          [isVisible]="showCropperDialog()"
          [imageBase64]="imageBase64()"
          (onConfirm)="handleCropConfirm($event)"
          (onCancel)="handleCropCancel()">
        </app-image-cropper-dialog>
      </div>

      <h3 class="mb-2 mt-3 fs-5">Coach Details</h3>
      <p class="text-secondary mb-3 fs-6">Enter the details for the primary coach at your club.</p>

      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <div class="field">
            <label for="firstName" class="form-label">First Name <span aria-hidden="true">*</span></label>
            <input pInputText id="firstName" name="firstName"
              [(ngModel)]="clubInformation.coachDetails.firstName"
              [class.ng-invalid]="submitted() && !clubInformation.coachDetails.firstName?.trim()"
              class="w-full" aria-required="true"
              [attr.aria-invalid]="submitted() && !clubInformation.coachDetails.firstName?.trim() ? true : null"
              [attr.aria-describedby]="submitted() && !clubInformation.coachDetails.firstName?.trim() ? 'firstName-error' : null" />
            @if (submitted() && !clubInformation.coachDetails.firstName?.trim()) {
              <small id="firstName-error" role="alert" class="p-error">First Name is required.</small>
            }
          </div>
        </div>
        <div class="col-md-6">
          <div class="field">
            <label for="lastName" class="form-label">Last Name <span aria-hidden="true">*</span></label>
            <input pInputText id="lastName" name="lastName"
              [(ngModel)]="clubInformation.coachDetails.lastName"
              [class.ng-invalid]="submitted() && !clubInformation.coachDetails.lastName?.trim()"
              class="w-full" aria-required="true"
              [attr.aria-invalid]="submitted() && !clubInformation.coachDetails.lastName?.trim() ? true : null"
              [attr.aria-describedby]="submitted() && !clubInformation.coachDetails.lastName?.trim() ? 'lastName-error' : null" />
            @if (submitted() && !clubInformation.coachDetails.lastName?.trim()) {
              <small id="lastName-error" role="alert" class="p-error">Last Name is required.</small>
            }
          </div>
        </div>
      </div>

      <div class="row g-3 mb-3">
        <div class="col-md-8">
          <div class="field">
            <label for="coachEmail" class="form-label">Coach Email <span aria-hidden="true">*</span></label>
            <input pInputText id="coachEmail" name="coachEmail" type="email"
              [(ngModel)]="clubInformation.coachDetails.email"
              [class.ng-invalid]="submitted() && (!clubInformation.coachDetails.email?.trim() || !isValidEmailFormat(clubInformation.coachDetails.email) || emailsMatch())"
              class="w-full" aria-required="true"
              [attr.aria-invalid]="submitted() && (!clubInformation.coachDetails.email?.trim() || !isValidEmailFormat(clubInformation.coachDetails.email) || emailsMatch()) ? true : null"
              [attr.aria-describedby]="submitted() && (!clubInformation.coachDetails.email?.trim() || !isValidEmailFormat(clubInformation.coachDetails.email) || emailsMatch()) ? 'coachEmail-error' : null" />
            @if (submitted() && !clubInformation.coachDetails.email?.trim()) {
              <small id="coachEmail-error" role="alert" class="p-error">Coach Email is required.</small>
            } @else if (submitted() && !isValidEmailFormat(clubInformation.coachDetails.email)) {
              <small id="coachEmail-error" role="alert" class="p-error">Enter a valid email address.</small>
            } @else if (submitted() && emailsMatch()) {
              <small id="coachEmail-error" role="alert" class="p-error">Coach Email cannot be the same as Admin Email.</small>
            }
          </div>
        </div>
        <div class="col-md-4">
          <div class="field">
            <label for="genderSelect" class="form-label">Gender <span aria-hidden="true">*</span></label>
            <p-select id="gender" inputId="genderSelect" name="gender"
              [(ngModel)]="clubInformation.coachDetails.gender"
              [options]="gendersDropdown" optionLabel="label" optionValue="value"
              placeholder="Select Gender" [filter]="false"
              [class.ng-invalid]="submitted() && !clubInformation.coachDetails.gender"
              ariaLabel="Coach Gender" panelStyleClass="comp-dark-panel"
              class="w-full" aria-required="true" />
            @if (submitted() && !clubInformation.coachDetails.gender) {
              <small id="gender-error" role="alert" class="p-error">Gender is required.</small>
            }
          </div>
        </div>
      </div>

      <div class="field mt-5">
        <app-button type="submit" label="Save and Next" variant="filled" color="primary" [fullWidth]="true"
          class="w-100 d-block">
        </app-button>
      </div>
    </form>
  </div>
</div>
